export const PLAN_ACCESS = {
  BASIC: 1 << 0,
  STANDARD: 1 << 1,
  ADVANCED: 1 << 2,
  PREMIUM: 1 << 4
};
